import React, {useEffect} from 'react'
import Aos from 'aos';
import "aos/dist/aos.css";
 

const OurServices = props =>{
    useEffect(()=>{
        Aos.init({duration: 3000})
    }, [])  
     return(
        <section>
            <div className="banner-image service1">
                <div className="ms-width">
                    <div className="py-5">
                        <h3 className="heading3 text-color1 pb-3 pt-4 font-weight-bold text-center" data-aos="fade-down">Our <span className="text-color2">Services</span></h3>
                        <h4 className="p2 text-center pt-3" data-aos="fade-up">Based on required information furnished by students, we provide guidance on desired destination, field of study, culture, living costs, etc.</h4>
                        <h4 className="p2 text-center mb-0 pt-3" data-aos="fade-up">  We encourage parents, sponsors, and other family members of students to join consulting sessions. Backed-up by a wide array of international expertise and knowledge, Delta Global Consultants will facilitate in providing students with useful information to take their next step in their educational and career endeavors.</h4>
                    </div>
                </div>
            </div>
        </section>
     )
}

export default OurServices;